<template>
    <div v-if="showLoader"
         style="position: fixed; top:0px; left: 0px; z-index:500; width: 100%; height: 100vh; background-color: rgba(7,7,7,.3); display: flex; justify-content: center; align-items: center"
    ></div>
    <button v-else="!showLoader && show" v-on:click="submitOperation"
            :disabled="!show"
            :title="title"
            :class="displayButtonClass"
    >
        <span v-if="!show" v-html="labelWhenHidden"></span>
        <template v-else>
            <template v-if="displayLabel">{{ displayLabel }}</template>
            <slot v-else></slot>
        </template>
    </button>
</template>

<script>
export default {
    props: {
        operationsUrl: {type: String},
        subject: {},
        action: {type: String},
        label: {type: String, default: null},
        title: {type: String, default: ''},
        successEvent: {type: String, default: 'submit-success'},
        failureEvent: {type: String, default: 'submit-failed'},
        labelWhenHidden: {type: String, default: ''},
        buttonClass: {type: String, default :''}
    },
    data: function () {
        return {
            show: true,
            showLoader: false,
            displayLabel: null,
            displayButtonClass: '',
        }
    },
    mounted() {
        this.displayLabel = this.label;
        this.displayButtonClass = this.buttonClass;
    },
    methods: {
        submitOperation: function() {
            this.showLoader = true;
            window.axios.post(this.operationsUrl, {
                action: this.action,
                subject: this.subject,
            }).then((response) =>{
                this.showLoader = false;
                this.$emit(this.successEvent, response.data);
                if (response.data.hideButton) {
                    this.show = false;
                }
                if (response.data.label) {
                    this.displayLabel = response.data.label;
                }
                if (response.data.buttonClass) {
                    this.displayButtonClass = response.data.buttonClass;
                }
                if (response.data.element) {
                    this.$emit('updated', response.data.element)
                }

            }).catch((error) => {
                this.showLoader = false;
                console.log(error);
                if (error.response) {
                    this.$emit(this.failureEvent, error.response.data);
                } else {
                    this.$emit(this.failureEvent, error);

                }
            })
        }
    },
    computed: {},
    watch: {}

}
</script>
